import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SwiperComponent } from '../../../common/components';
import { NodeModel } from '../../../common/models';
import { LearningPathCardComponent } from '../../../learning-path-card/components/learning-path-card/learning-path-card.component';


@Component({
    selector: 'lib-learning-paths-widget',
    templateUrl: './learning-paths-widget.component.html',
    styleUrls: ['./learning-paths-widget.component.scss'],
    standalone: false
})
export class LearningPathsWidgetComponent {
  @Input() public paths: NodeModel[] = [];
  @Input() public textColor: string;
  @Input() public title: string;
  @Input() public langcode: string;

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  @Output() public navigateToPath: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public startPath: EventEmitter<{ item: NodeModel, component: LearningPathCardComponent }> = new EventEmitter();

  public carouselConfig = {
    breakpoints: {
      0: {
        slidesPerView: 1,
        reducedWidth: true,
        showOverflow: true
      },
      480: {
        slidesPerView: 1,
        reducedWidth: false,
        showOverflow: false
      }
    }
  };
}
